import styles from "../Report2.module.css";

export default function Report2({goHome}) {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <h1>U.S. NAVAL AERO</h1>
          </div>

          <div>
            <h2>Field Maintenance Ledger — FA/18 Service Section</h2>
            <p className={styles.lead}>
            </p>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.stamp}>CLASSIFIED — TECH ONLY</div>
            <div className={styles.form}>Form: RAN-18-2015</div>
          </div>
        </header>

        <section className={styles.reports}>
          <article className={styles.report}>
            <div className={styles.meta}>
              <div className={styles.metaLeft}>
                <strong>Service Report:</strong> FA/18 — BuNo 94512 (Follow-Up)
                <div className={styles.metaSub}>
                  Date: June 14, 2015 &nbsp; | &nbsp; Location: Materiel Depot
                </div>
              </div>

              <div className={styles.metaRight}>
                Techs: L. K. Hargrove (A&amp;SM 2nd Class), Cpl. Tomaso — Ground Crew
              </div>
            </div>

            <h3>Landing Gear — Shock Strut Service &amp; Brake Check</h3>

            <table className={styles.log}>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Observation</th>
                  <th>Action Taken</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Nose Gear</td>
                  <td>
                    Shock strut low on nitrogen charge; slight drag on swivel.
                  </td>
                  <td>
                    Serviced strut to 1,150 psi precharge; applied lubricant to
                    swivel bearings; replaced cotter pin on assembly.
                  </td>
                </tr>
                <tr>
                  <td>Main Gear — RH</td>
                  <td>Pad wear within tolerances; brake thermal discoloration.</td>
                  <td>
                    Measured pad thickness 0.145&quot; — above minimum 0.120&quot;.
                    Cleaned heat stains; performed brake retraction test (pass).
                  </td>
                </tr>
                <tr>
                  <td>Hydraulic Lines</td>
                  <td>No leaks found; fluid at service mark.</td>
                  <td>
                    Hydraulic fluid topped to service mark; bled system per
                    procedure H-2/4.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className={styles.note}>
              Note: !!! CLASSIFIED !!! All personnel are to encode/decode using the
              methodology codename "Et Tu, Brute?" I'm not exactly sure why management
              decided to get on our ass about it but Johnson used the wrong shift
              to encode again. Remember, it's the last two numbers of the year
              Obama started his second term. Rules are rules. Also, don't forget to put the form letters for each report in order BEFORE, not afterwards (looking at you, Johnson)
            </div>

            <div className={styles.checklist}>
              <strong>Checklist:</strong>
              <ul className={styles.check}>
                <li className={styles.checked}>Shock strut service — complete</li>
                <li className={styles.checked}>Brake functional test — complete</li>
                <li className={styles.checked}>Hydraulic bleed — complete</li>
                <li>Wheel alignment — deferred (requires hoist)</li>
              </ul>
            </div>

            <div className={styles.sig}>
              <div className={styles.signBlock}>
                <span className={styles.signature}>L. K. Hargrove</span>
                <div className={styles.initials}>
                  A&amp;SM 2nd Class — Gear Section
                </div>
              </div>

              <div className={styles.signRight}>
                <span className={styles.signature}>Cpl. F. Tomaso</span>
                <div className={styles.signSub}>
                  Ground Crew — Materiel Depot
                </div>
              </div>
            </div>
          </article>
        </section>

        <footer className={styles.footer}>
          <button onClick={goHome}>← Back to Home</button>
        </footer>
      </div>
    </div>
  );
}
